import { cn } from "@/utils/classnames";

type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

function Container({ className, ...props }: ContainerProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-300 px-5 md:px-10 xl:px-8",
        className
      )}
      {...props}
      data-testid="container"
    />
  );
}

export { Container, type ContainerProps };
